module.exports = __webpack_public_path__ + "static/media/Syndra_0.2112c8e3.jpg";